import { Component, OnInit } from '@angular/core';
import { PosHttpService } from '../../services/pos.http.service';
import { Subject } from 'rxjs';
import { FnModalService, FnTableConfig, FnTableMetaData, FnToasterService, FnUtilService, TABLE_ACTION_TYPE, TableAction } from 'foundation';
import { EOProduct, EOStatusType } from '../../modal/entity.modal';
import { DatePipe } from '@angular/common';
import { HistInfoModelComponent } from '../report/app-status-history/hist-info-model/hist-info-model.component';

@Component({
    selector: 'sla',
    templateUrl: './sla.component.html',
    styleUrl: './sla.component.scss'
})
export class SlaComponent implements OnInit {
    constructor(private fnModalSvcs: FnModalService, private posHttpSvcs: PosHttpService, public datepipe: DatePipe, private toaster: FnToasterService, private fnutilservice: FnUtilService) {
    }

    startDate: any;
    endDate: any;
    currentDate = new Date();
    selectProduct: any;
    selectIdenNo: any;
    showData = false;
    productArray: EOProduct[] = [];
    idenNoArray: EOStatusType[] = [];
    maxDateRange = new Date();
    isDisabled = false;
    isResolvedBySystem = false;
    uiMap = {
        isDataLoaded: false,
    };
    refPrimaryKey: any;
    description = "";
    severityArray = ['Sev 1', 'Sev 2', 'Sev 3'];
    selectSeverity: string = "";
    dateRangeObject = {
        startDate: new Date(),
        endDate: new Date()
    };
    isSLA = true;
    durationArray = [
        { "key": 1, "value": "> 1 Hour" },
        { "key": 2, "value": "> 2 Hours" },
        { "key": 4, "value": "> 4 Hours" },
        { "key": 6, "value": "> 6 Hours" },
        { "key": 12, "value": "> 12 Hours" },
        { "key": 24, "value": "> 24 Hours" },
        { "key": 48, "value": "> 2 Days" }
    ]
    selectDuration: string = "";

    changeDate(event: any) {
        this.startDate = this.datepipe.transform(event.startDate, 'yyyy-MM-dd');
        this.endDate = this.datepipe.transform(event.endDate, 'yyyy-MM-dd');
    }

    ngOnInit(): void {
        this.dateRangeObject.startDate.setDate(this.currentDate.getDate() - 7);
        this.dateRangeObject.endDate.setDate(this.currentDate.getDate());
        this.startDate = this.datepipe.transform(this.dateRangeObject.startDate, 'yyyy-MM-dd');
        this.endDate = this.datepipe.transform(this.dateRangeObject.endDate, 'yyyy-MM-dd');
        this.loadEOProduct();
    }

    loadEOProduct() {
        this.posHttpSvcs.authGet('v1/ui/loadProductName', 'loadProductName').subscribe((resp: any) => {
            if (resp.isError) {
                this.toaster.error('Product name not loaded');
                return;
            }
            this.productArray = resp.data;
        });
    }

    filterIdenNo() {
        this.selectIdenNo = '';
        this.posHttpSvcs.authPost('v1/ui/loadIdenNo', 'loadIdenNo', this.selectProduct).subscribe((resp: any) => {
            if (resp.isError) {
                this.toaster.error('Product not Selected');
                return;
            }
            this.idenNoArray = resp.data;
        })
    }

    refreshTableData() {
        if (this.config.tableAction.closed) {
            this.config.tableAction = new Subject<TableAction>();
        }
        this.config.tableAction.next({
            data: this.alertArray,
            action: TABLE_ACTION_TYPE.REFRESH,
        });
    }

    getHistData(selectIdenNo: number) {
        if (!this.isSLA && this.fnutilservice.isEmptyObject(this.selectDuration)) {
            this.toaster.error('Duration cannot be blank');
            return;
        }
        const requestMap: any = {
            product: this.selectProduct,
            startDate: this.startDate,
            endDate: this.endDate,
            idenNo: this.selectIdenNo,
            severity: this.selectSeverity,
            isSLA: this.isSLA,
            selectDuration: this.selectDuration
        }
        this.posHttpSvcs.authPost('v1/ui/loadSltAlerts', 'loadSltAlerts', requestMap).subscribe((resp: any) => {
            if (resp.isError) {
                this.toaster.error('Something went wrong');
                this.uiMap.isDataLoaded = false;
                return;
            }
            this.alertArray = resp.data;
            this.refreshTableData();
            this.uiMap.isDataLoaded = true;
        })
    }

    infoRowAction(row: any) {
        const RowInfoModel = this.fnModalSvcs.openCustomModal(HistInfoModelComponent, {
          data: {
            extraInfo: row.alertID
          },
          hasBackdrop: true,
          width: '1000px'
        })
        RowInfoModel.backdropClick().subscribe(() => {
          RowInfoModel.close();
        })
      }

downloadCsv() {
    const headers = ['Alert ID', 'Severity', 'Product', 'Started At', 'Alert Info', 'Description', 'Sender', 'Alert Count', 'Resolved At', 'Duration'];
    const csvData = (this.alertArray as any[]).map(row => [
      row.alertID || '',
      row.priority || '',
      row.product || '',
      row.alertStartedAt || '',
      row.alertInfo || '',
      row.description || '',
      row.source || '',
      row.count || '',
      row.resolvedAt || '',
      row.duration || ''
    ]);

    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent += headers.join(',') + '\n';
    csvContent += csvData.map(e => e.map(value => `"${value}"`).join(',')).join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'alert_history_report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

    alertArray: Array<{
        alertID: string;
        priority: string;
        product: string;
        alertStartedAt: string;
        alertInfo: string;
        description: string;
        source: string;
        count: string;
        resolvedAt: string;
        duration: string;

    }> = [];

    config: FnTableConfig = {
        uniqueKey: 'primaryKey',
        defaultSortKey: 'primaryKey',
        tableAction: new Subject<TableAction>(),
        hideAction: false,
        hideDelete: true,
        hideEdit: true,
        isCustomTemplate: true
    };

    rowMetaArray: FnTableMetaData[] = [
        {
            key: 'primaryKey',
            description: 'Primary Key',
            isHidden: true,
            isSortable: true,
            type: 'number',
        },
        {
            key: 'alertID',
            description: 'ID',
            type: 'string',
            isSortable: true,
        },
        {
            key: 'priority',
            description: 'Severity',
            type: 'string',
            isSortable: true,
        },
        {
            key: 'product',
            description: 'Product',
            type: 'string',
            isSortable: true,
        },
        {
            key: 'alertStartedAt',
            description: 'Started At',
            type: 'datetime',
            isSortable: true,
        },
        {
            key: 'alertInfo',
            description: 'Alert Info',
            type: 'string',
            isSortable: true,
        },
        {
            key: 'description',
            description: 'Description',
            type: 'string',
            isSortable: true,
        },
        {
            key: 'source',
            description: 'Sender',
            type: 'string',
            isSortable: true,
        },
        {
            key: 'count',
            description: 'Alert Count',
            type: 'string',
            isSortable: true,
        },
        {
            key: 'resolvedAt',
            description: 'Resolved At',
            type: 'datetime',
            isSortable: true,
        },
        {
            key: 'duration',
            description: 'Duration',
            type: 'string',
            isSortable: true,
        }

    ];

}
